import { withProps } from 'recompose';

export default name => withProps({ e2e: name });
